import { useAppSelector } from 'shared/lib';

import { whiteLabelAffIdSelector } from 'entities/whiteLabels';

import { FormStepTitleConfig } from './FormStepTitle.config';

export const useFormStepTitleComponent = () => {
  const partnerId = useAppSelector(whiteLabelAffIdSelector);

  if (!partnerId) {
    return null;
  }

  const WlStepTitle = FormStepTitleConfig[partnerId] || null;

  if (!WlStepTitle) {
    return null;
  }

  return WlStepTitle;
};
